import React, { useEffect } from "react";
import { TipoFormulario } from "../../services/constantes";

interface CampoProps {
    nome: string;
    tipo: "decimal" | "monetario" | "percentual";
    required?: boolean;
    modo: TipoFormulario;
}

interface DecimalMonetarioProps {
    campo: CampoProps;
    getFieldValue: (nome: string) => string | number;
    handleInputChange: (nome: string, value: number) => void;
    largura?: string;
    valorInicial?: number;
    apenasLeitura?: boolean;
    onBlur?: (e: any) => void;
    hasError?: boolean;
}

const DecimalMonetario: React.FC<DecimalMonetarioProps> = ({
    campo,
    getFieldValue,
    handleInputChange,
    largura = "100%",
    valorInicial,
    apenasLeitura = false,
    onBlur,
    hasError = false
}) => {
    const formatValue = (rawValue: string): string => {
        const numericValue = parseInt(rawValue.replace(/\D/g, ""), 10) || 0;
        const decimalValue = (numericValue / 100).toFixed(2);

        const parts = decimalValue.split(".");
        const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        const decimalPart = parts[1];

        return `${integerPart},${decimalPart}`;
    };

    const parseValue = (formattedValue: string): number => {
        return parseFloat(
            formattedValue.replace(/[^\d,-]/g, "").replace(",", ".") || "0"
        );
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value.replace(/\D/g, "");
        const formattedValue = formatValue(inputValue);
        handleInputChange(campo.nome, parseValue(formattedValue));
    };

    useEffect(() => {
        if (valorInicial !== undefined) {
            handleInputChange(campo.nome, valorInicial);
        }
    }, []);

    const fieldValue = String(getFieldValue(campo.nome) || "0").replace(",", ".");
    const displayValue = formatValue((parseFloat(fieldValue) * 100).toFixed(0));

    return (
        <div style={{ width: largura }}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    overflow: "hidden",
                    backgroundColor: apenasLeitura ? "#f5f5f5" : "#fff",
                    ...(hasError && {
                        boxShadow: "0 0 0 0.2rem rgba(220, 53, 69, 0.25)"
                    })
                }}
            >
                {campo.tipo === "monetario" && (
                    <div
                        style={{
                            backgroundColor: "#f9f9f9",
                            padding: "6px 8px",
                            borderRight: "1px solid #ccc",
                            fontSize: "14px",
                            color: "#333",
                            whiteSpace: "nowrap",
                        }}
                    >
                        R$
                    </div>
                )}
                <input
                    type="text"
                    disabled={apenasLeitura}
                    onChange={handleChange}
                    placeholder="0,00"
                    required={campo.required}
                    readOnly={campo.modo === TipoFormulario.tpVisualizacao}
                    value={displayValue}
                    style={{
                        flex: 1,
                        padding: "6px 8px",
                        border: "none",
                        fontSize: "14px",
                        fontFamily: "inherit",
                        backgroundColor: "transparent",
                        outline: "none",
                        textAlign: "right",
                    }}
                    onBlur={onBlur}
                />
                {campo.tipo === "percentual" && (
                    <div
                        style={{
                            backgroundColor: "#f9f9f9",
                            padding: "6px 8px",
                            borderLeft: "1px solid #ccc",
                            fontSize: "14px",
                            color: "#333",
                            whiteSpace: "nowrap",
                        }}
                    >
                        %
                    </div>
                )}
            </div>
        </div>
    );
};

export default DecimalMonetario;
